import Image1 from "../../assets/testimonial.jpg";

export const Data = [
    {
        id: 1,
        image: Image1,
        title: "Ucok Silalahi",
        description:
            "I am very impressed with Nandi Rifaldi skills and dedication. As a frontend developer, he always manages to deliver user interfaces that are not only aesthetically pleasing, but also functional and responsive across devices. His creativity in design, combined with a deep technical knowledge of technologies such as React, Tailwind CSS, and TypeScript, makes each of his projects of exceptional quality. He is also very open to feedback and always tries to deliver the best results according to the client's needs. I have no hesitation in recommending Nandi Rifaldi for any frontend project.",
    },
    {
        id: 2,
        image: Image1,
        title: "Muhammad Cristian",
        description:
            "Working with Nandi Rifaldi was a great experience. He has the ability to transform abstract concepts into engaging and user-friendly web designs. His coding skills, deep understanding of UX/UI, and ability to collaborate with teams make him a valuable asset in every project. Very professional and always on time in completing his tasks.",
    },
    {
        id: 3,
        image: Image1,
        title: "Sigit Rendang",
        description:
            "If you're looking for a frontend developer who can bring your ideas to life in a stunning digital reality, Nandi Rifaldi is your man. His dedication, work efficiency, and outstanding results are truly impressive. Highly recommended!",
    },
]